<template>
  <div class="container block_screen">
    <div class="">
      <div class="first_page">
        <div class="container--small">
          <i class="icon-Product-Icon_HDM_Suite main-icon f-blue"></i>
          <p class="promo-text">
            Welcome to
          </p>
          <h1>Migrate data/OS</h1>
          <p class="desc">
            &nbsp;
          </p>
          <ul class="hdm_list">
            <li><a data-name="Copy disk" @click.prevent="changeScreen(54)" class="tellus gotolast" href="#">Copy disk</a></li>
            <li><a data-name="Copy operating system" @click.prevent="changeScreen(58)" class="tellus gotolast" href="#">Copy operating system</a></li>
          </ul>
          <br>
          <p class="desc">
            Pick your scenario and see how it works in HDM!
            <br>
          </p>
          <br>
          <br>
          <br>
          <br>
          <div class="btn_right">
            <a data-name="skip" href="" @click.prevent="changeScreen(100)"
               class="btn btn_orange">Skip</a>
          </div>
        </div>
      </div>
    </div>
    <div class="btn_left">
      <a data-name="back" href="" @click.prevent="changeScreen(0)"
         class="btn btn_orange">Back</a>
    </div>
  </div>
</template>
<script>
  import {mapMutations} from 'vuex'
  export default {
    methods: {
      ...mapMutations({
        changeScreen: 'setScreen' // map `this.add()` to `this.$store.commit('increment')`
      })
    },
  };
</script>
